import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { associationLabelGet, getAssociationLabel } from '@collections/association-label';
import { AssociationLabel } from '@shared/models';

@Component({
  selector: 'mojo-association-label',
  templateUrl: './association-label.component.html',
  styleUrls: ['./association-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssociationLabelComponent implements OnChanges {
  @Input()
  candidateId: number;

  @Input()
  jobId: number;

  @Input()
  internal = false;

  private associationData$ = new ReplaySubject<{ jobId: number; candidateId: number }>(1);

  associationLabel$: Observable<{ label: string; text: string }> = this.associationData$.pipe(
    switchMap((props) => this.store.select(getAssociationLabel, props)),
    filter((label) => !!label),
    map((label) => ({ label, text: this.labelText(label) })),
  );

  constructor(private store: Store) {}

  ngOnChanges(change: SimpleChanges) {
    if (
      (change.jobId?.currentValue !== change.jobId?.previousValue ||
        change.candidateId?.currentValue !== change.candidateId?.previousValue) &&
      !!this.jobId &&
      !!this.candidateId
    ) {
      const props = {
        jobId: this.jobId,
        candidateId: this.candidateId,
      };

      this.store.dispatch(associationLabelGet(props));
      this.associationData$.next(props);
    }
  }

  private labelText(associationLabel: AssociationLabel | string) {
    if (associationLabel === AssociationLabel.DIRECT) {
      return 'DIRECT APPLICANT';
    } else {
      return `${associationLabel.replaceAll('_', ' ')} CANDIDATE`;
    }
  }
}
